'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsHourly = getIsHourly;
exports.createReservedSchedules = createReservedSchedules;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _smConst = require('../constants/sm-const');

var _smConst2 = _interopRequireDefault(_smConst);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 与えられた情報からその予約が時間貸しかどうかを返します
 * @export
 * @param {Object} plan 選択されたプラン(APIから取得したデータをそのまま渡してください)
 * @param {boolean} isHourly 予約のis_hourlyか、個別にStateとして管理している場合はその値を渡します
 * @returns
 */
function getIsHourly(plan, isHourly) {
  return plan.has_hourly_price && !plan.has_daily_price || plan.has_session_price && plan.min_required_session_hour_unit === _smConst2.default.RequiredUnit.Hour || plan.has_hourly_price && plan.has_daily_price && isHourly;
}

/**
 * 与えられた情報から予約のスケジュールを作成し返します
 * @export
 * @param {boolean} isHourly 時間貸しかどうか
 * @param {Object} plan 選択されたプラン(APIから取得したデータをそのまま渡してください)
 * @param {moment} startedAt 開始日時(時間貸しの場合は開始時間、宿泊の場合はチェックイン時間をセットしてください)
 * @param {moment} endedAt 終了日時(時間貸しの場合は開始時間、宿泊の場合はチェックアウト時間をセットしてください)
 * @returns 予約のスケジュール配列(reserved_schedules)
 */
function createReservedSchedules(isHourly, plan, startedAt, endedAt) {
  // 時間貸しの場合or一日貸しの場合でschedulesの作り方を分ける
  var schedules = [];
  if (isHourly) {
    // 時間貸しの場合
    var _duration = endedAt.diff(startedAt, 'minutes');
    schedules.push({
      started_at: startedAt.utc().toDate(),
      duration: _duration
    });
  } else {
    // 一日貸しの場合
    var targetDate = (0, _moment2.default)(startedAt);
    // 一日ごとに分ける
    do {
      schedules.push({
        started_at: _moment2.default.utc([targetDate.year(), targetDate.month(), targetDate.date()]).toDate(),
        duration: 1440
      });
      targetDate.add(1, 'days');
    } while (!targetDate.isSameOrAfter(endedAt));
  }

  // 設定した開始・終了日の分数を求める
  // その分数を以下の条件でスケジュールごとに分けてArrayにする
  // - 利用時間(分)
  // 時間価格：60分ごとに分割する
  // 1日価格：日ごとに分解し1440をセットする
  // 宿泊：チェックインからチェックアウトまでの時間

  var isStay = (plan || {}).has_stay_price;
  var isSession = (plan || {}).has_session_price;
  var minRequiredSessionHour = (plan || {}).min_required_session_hour;
  var minRequiredSessionHourUnit = (plan || {}).min_required_session_hour_unit;

  // 宿泊の場合、開始〜終了日の分をdurationを設定
  // is_stay_start に true をセットする
  if (isStay) {
    return [{
      duration: endedAt.diff(startedAt, 'minutes'),
      started_at: startedAt.utc().format(),
      stay_checkin_at: (0, _moment2.default)(startedAt).utc().format(),
      is_stay_start: 1
    }];
  }

  // セッションを分単位に直しsessionDurationに格納
  var sessionDuration = minRequiredSessionHour * 60;
  if (minRequiredSessionHourUnit === _smConst2.default.RequiredUnit.Day) {
    sessionDuration = minRequiredSessionHour * 60 * 24;
  }
  // スケジュールに入れる単位をdurationに格納
  var duration = 60;
  if (!isHourly) {
    duration = 1440;
  }

  // スケジュールに入れる単位に分割しreservedSchedulesに格納
  var reservedSchedules = [];
  // セッションごとの分を累積する変数
  var stackSessionDuration = 0;
  schedules.forEach(function (schedule) {
    var durationRemain = schedule.duration;
    var scheduleStartedAt = (0, _moment2.default)(schedule.started_at);
    while (durationRemain > 0) {
      var currentDuration = duration;
      if (durationRemain < duration) {
        currentDuration = durationRemain;
      }

      reservedSchedules.push({
        duration: currentDuration,
        started_at: scheduleStartedAt.utc().format(),
        is_session_start: 0
      });

      if (isSession) {
        // セッション価格用の処理
        if (stackSessionDuration >= sessionDuration) {
          stackSessionDuration -= sessionDuration;
        }
        if (stackSessionDuration < duration) {
          reservedSchedules[reservedSchedules.length - 1].is_session_start = true;
        }
        stackSessionDuration += duration;
      }

      durationRemain -= duration;
      scheduleStartedAt = scheduleStartedAt.add(duration, 'minutes');
    }
  });
  return reservedSchedules;
}


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/helpers/reservation.js
// module id = 2090
// module chunks = 0